$("#openModalBtn").click(function () {
  // Get the modal and modal content elements
  var modal = new bootstrap.Modal(document.getElementById("modalAddEdit"));
  var modalContent = $("#modalContent");

  // Perform AJAX request to fetch content
  $.ajax({
    url: "api__loadModalChange", // Replace 'your_content_url' with the URL that returns the content you want to load.
    type: "GET",

    success: function (response) {
      // Update modal content with the fetched data
      modalContent.html(response);
      // Show the modal

      modal.show();
      initSelect2();
      let collections_id = jQuery(".appCollectionMyDetailForChange").data(
        "collections_id"
      );
      if (collections_id > 0) {
        Collections_component.load_component();
      }
      resetSeleccionList();
    },
    error: function () {
      modalContent.html("Error loading content.");
    },
  });
});

$("body").on("shown.bs.modal", "#modalAddEdit", function (e) {
  //alert('selectionListA:'+selectionListA.join(","))
  //alert('selectionListB:'+selectionListB.join(","))
  // do something...
});

$("body").on("click", ".deleteChange", function () {
  // Get the modal and modal content elements

  var confirmacion = confirm(
    "¿Estás seguro de que quieres eliminar esta fila?"
  );
  if (confirmacion) {
    let changesId = $(this).data("id");
    // Perform AJAX request to fetch content
    $.ajax({
      url: "/api/api__deleteChange?changesId=" + changesId, // Replace 'your_content_url' with the URL that returns the content you want to load.
      type: "GET",

      success: function (response) {
        changeTable.ajax.reload();
      },
      error: function () {
        alert("Error loading content.");
      },
    });
  }
});

jQuery("body").on("custom__modalChangeFinish", function (e, a, b) {
  console.log("custom__modalChangeFinish....");
  console.log(a);
  console.log(b);
  changeTable.ajax.reload();
  $("#modalAddEdit").modal("hide");
});

$("body").on("click", ".editChange", function () {
  // Get the modal and modal content elements
  var modal = new bootstrap.Modal(document.getElementById("modalAddEdit"));
  var modalContent = $("#modalContent");

  let changesId = $(this).data("id");
  // Perform AJAX request to fetch content
  $.ajax({
    url: "api__loadModalChange?changesId=" + changesId, // Replace 'your_content_url' with the URL that returns the content you want to load.
    type: "GET",

    success: function (response) {
      // Update modal content with the fetched data
      modalContent.html(response);
      // Show the modal

      modal.show();
      initSelect2();
      let collections_id = jQuery(".appCollectionMyDetailForChange").data(
        "collections_id"
      );
      if (collections_id > 0) {
        Collections_component.load_component();
      }
      resetSeleccionList();
      jQuery(document)
        .off("load_component_finish")
        .on("load_component_finish", function (e) {
          let listid_a = jQuery(
            ".listItemsA input.listIds",
            modalContent
          ).val();
          let listid_b = jQuery(
            ".listItemsB input.listIds",
            modalContent
          ).val();

          iterarPorComas(listid_a, ".listItemsA", modalContent);
          iterarPorComas(listid_b, ".listItemsB", modalContent);
          // alert("listid_a="+listid_a)
          // alert("listid_b="+listid_b)
        });
    },
    error: function () {
      modalContent.html("Error loading content.");
    },
  });
});

$("body").on("click", ".infoChange", function () {
    // Get the modal and modal content elements
    var modal = new bootstrap.Modal(document.getElementById("modalAddEdit"));
     
    var row = $(this).closest("tr");
    var nombre = row.find("td:eq(1)").html();
    var coleccion = row.find("td:eq(2)").html();
    var itemsEntregar = row.find("td:eq(3)").html();
    var stickersRecibir = row.find("td:eq(4)").html();
    var currentDate = new Date().toLocaleDateString(); // Obtener la fecha actual
    var placeholderText = "ESCRIBE TU NOMBRE AQUÍ";

    var htmlInfo = `
    <table class="table table-bordered text-center">
        <thead>
            <tr>
                <th colspan="4" class="fs-4 fw-bold">INTERCAMBIO</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td colspan="4" class="fs-5 text-uppercase">${coleccion} <br>
                            <small>${currentDate}</small></td>
            </tr>
            <tr class=" text-white">
                <td colspan="2" class=" bg-danger fs-5 text-uppercase">${nombre}</td>
                <td colspan="2"  class="bg-secondary"></td>
            </tr>
            <tr>
                <td class="text-danger"  ><i class="bi bi-box-arrow-down fs-4"></i></td>
                <td><div id="changeTable">${stickersRecibir}</div></td>
                <td class="text-success"><i class="bi bi-box-arrow-up fs-4"></i></td>
                <td><div id="changeTable">${itemsEntregar}</div></td>
            </tr>
            <tr class=" text-white">
                <td colspan="2" class="bg-secondary"></td> 
                <td colspan="2" class=" bg-success fs-5 text-uppercase">
                    <div id="editableName" contenteditable="true" class="editable-placeholder">${placeholderText}</div>
                </td>
            </tr>
        </tbody>
    </table>
`;
    $("#modalContent").html(htmlInfo);

    var editableName = $("#editableName");
    
    editableName.on("focus", function() {
        if ($(this).text() === placeholderText) {
            $(this).text("");
            $(this).removeClass("placeholder-style");
        }
    });

    editableName.on("blur", function() {
        if ($(this).text().trim() === "") {
            $(this).text(placeholderText);
            $(this).addClass("placeholder-style");
        }
    });

        modal.show();
        
  });

function iterarPorComas(cadena, targetClass, context) {
  // Dividir la cadena en un array utilizando la coma como delimitador

  var arrayElementos = cadena.split(",");

  // Iterar cada elemento del array utilizando .each()
  $.each(arrayElementos, function (index, elemento) {
    console.log("arrayElementos=" + elemento);
    // Eliminar los espacios en blanco al inicio y al final del elemento
    var elementoSinEspacios = elemento.trim();

    // Aquí puedes realizar cualquier acción con cada elemento
    // Por ejemplo, imprimirlo en el div con id="resultado"
    jQuery(
      targetClass + "  .milista-element[data-id='" + elementoSinEspacios + "']",
      context
    ).addClass("highlight");

    contador =
      jQuery(
        targetClass +
          "  .milista-element[data-id='" +
          elementoSinEspacios +
          "']",
        context
      ).data("contador") ?? 0;
    contador = contador + 1;

    jQuery(
      targetClass + "  .milista-element[data-id='" + elementoSinEspacios + "']",
      context
    ).data("contador", contador);
    // vamos a ver el contador del elemento

    let elementIterable = jQuery(
      targetClass + "  .milista-element[data-id='" + elementoSinEspacios + "']",
      context
    );
    jQuery(elementIterable).find(".badge-center").remove();
    if (contador > 0) {
      jQuery(elementIterable).append(
        '<span class="badge-center position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger">' +
          +parseInt(contador) +
          "</span>"
      );
    }

    numero = jQuery(
      targetClass + "  .milista-element[data-id='" + elementoSinEspacios + "']",
      context
    )
      .find(".number")
      .text()
      .trim();
    if (targetClass == ".listItemsA") {
      //selectionListA.push(numero);
      addElementListAChanges(numero, contador);
    } else {
      //selectionListB.push(numero);
      addElementListBChanges(numero, contador);
    }
  });

  jQuery(targetClass + "  span.milista-element ", context).addClass(
    "offFilter"
  );

  jQuery(
    targetClass + "  span.milista-element  span.bg-danger",
    context
  ).addClass("offFilter");
}
function initSelect2() {
  $("#selectRecibira, #selectDara").select2({
    tags: true,
    dropdownParent: $("#modalAddEdit"),
    createTag: function (params) {
      return undefined;
    },
    ajax: {
      url: "/my/api_getMyItemsOfCollections", // Replace 'URL_AJAX' with your AJAX endpoint URL
      dataType: "json",
      delay: 250,
      processResults: function (data) {
        return {
          results: data,
        };
      },
      cache: true,
      data: function (params) {
        // Obtener el ID del select2 dinámicamente utilizando 'this'
        var selectId = $(this).attr("id");

        var collections_id = $("#selectColeccion").val();
        return {
          id: selectId,
          todos: $("#" + selectId + "Todos").is(":checked") ? 1 : 0,

          collections_id: collections_id,
          term: params.term, // Término de búsqueda ingresado por el usuario
          page: params.page, // Número de página
        };
      },
    },
  });

  $("#selectColeccion.form-select").select2({
    dropdownParent: $("#modalAddEdit"),
    ajax: {
      url: "/my/api_getMyCollectionsSelect", // Replace 'URL_AJAX' with your AJAX endpoint URL
      dataType: "json",
      delay: 250,
      processResults: function (data) {
        return {
          results: data,
        };
      },
      cache: true,
    },
  });

  $(document.body)
    .off("change", "#selectColeccion.form-select")
    .on("change", "#selectColeccion.form-select", function () {
      context = jQuery("#modalAddEdit");
      let val = $(this).val();
      jQuery(".appComponent").data("collections_id", val);
      let collections_id = jQuery(".appCollectionMyDetailForChange").data(
        "collections_id"
      );
      if (collections_id > 0) {
        Collections_component.load_component();
      }
    });

  //api_getChangesContacts
  $("#changeContact").select2({
    tags: true,

    dropdownParent: $("#modalAddEdit"),
    ajax: {
      url: "/my/api_getChangesContacts", // Replace 'URL_AJAX' with your AJAX endpoint URL
      dataType: "json",
      delay: 250,
      processResults: function (data) {
        return {
          results: data,
        };
      },
      cache: true,
    },
  });

  $("#selectColeccion").on("change", function () {
    // Reiniciar los campos 'dara' y 'recibira' estableciendo sus valores como vacíos
    $("#selectDara").val(null).trigger("change");
    $("#selectRecibira").val(null).trigger("change");
  });

  // Escuchar el evento de cambio de 'dara'
  $("#selectDara").on("change", function () {
    var cantidadDara = $(this).val().length;
    actualizarCantidadItems(cantidadDara, "dara");
  });

  // Escuchar el evento de cambio de 'recibira'
  $("#selectRecibira").on("change", function () {
    var cantidadRecibira = $(this).val().length;
    actualizarCantidadItems(cantidadRecibira, "recibira");
  });

  // Función para actualizar el label con la cantidad de ítems seleccionados
}
function actualizarCantidadItems(cantidad, ubicacion) {
  if (ubicacion == "dara") {
    $("#labelCantidadDara").text("");
    if (cantidad > 0) {
      $("#labelCantidadDara").text(cantidad + " elementos seleccionados");
    }
  } else {
    $("#labelCantidadRecibira").text("");
    if (cantidad > 0) {
      $("#labelCantidadRecibira").text(cantidad + " elementos seleccionados");
    }
  }
}
